import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getDescriptionData } from '../HeadlinesSection/helpers'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleOptionsField from '../../../../../../ReusableFormFields/MultipleOptionsField'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { getInitialValues, validationSchema } from './fields'
import { DESCRIPTIONS_LIST } from '../../../../fields'

const DescriptionsSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalDescriptionAssets = useMemo(() => getDescriptionData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalDescriptionAssets), [originalDescriptionAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalDescriptionAssets,
    fieldType: googleAssetFieldType.DESCRIPTION,
    sectionValueKey: DESCRIPTIONS_LIST,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    validationSchema,
    title,
    adAccount
  })

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      {...formProps}
    >
      <MultipleOptionsField
        fieldLabel="Description"
        listFieldName={DESCRIPTIONS_LIST}
        formik={purifiedFormik}
        minListQuantity={2}
      />
    </EditForm>
  )
}

export default DescriptionsSectionForm
